import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const OnBoardingReviewsPage = styled(IonPage)`
  & ion-header {
    background: #177590;

    & button {
      color: #ffffff;
    }
  }

  & ion-toolbar {
    --background: #177590;
  }

  & ion-content {
    --background: #177590;
  }

  & ion-progress-bar {
    &::part(track) {
      background: #e8ecf2;
    }

    &::part(progress) {
      background: #21abd2;
    }
  }

  & .reviews-title {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #ffffff;
    margin-bottom: 24px;
  }
`;

export const OnBoardingReviewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  & .review-item {
    padding: 16px;
    border: none;
    background: #ffffff;
    border-radius: 10px;
  }
`;
